import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { DataTable } from 'components';
import { useAuth } from 'contexts';
import { useNewTransaction } from 'pages/new-transaction';
import { defaultTransactionColumns, transactionDataColumns } from 'pages/transactions/grid/transaction-columns';
import { fetchDrafts } from 'services';
import { downloadCsv } from 'services/download-csv';

import './yard-management.scss';

const Drafts: FC = () => {
  const navigate = useNavigate();
  const { restoreTransaction } = useNewTransaction();
  const { userProfile } = useAuth();

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'TRANSACTION').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'TRANSACTION')
          .map(({ column }) => {
            return { field: column, width: 80 };
          })
      : defaultTransactionColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  return (
    <div className="page" id="gate-drafts">
      <div className="page-header">
        <h1>PENDING TRANSACTIONS</h1>
        <button className="btn-back d-flex g-2 text-info-dark" onClick={() => navigate('/gate')}>
          BACK TO GATE ACCESS
          <span className="material-icons icon-large">home</span>
        </button>
      </div>
      <div className="flex-fill">
        <DataTable
          fetchData={fetchDrafts}
          fetchCsv={downloadCsv('transactions')}
          columns={transactionDataColumns.map(({ renderCell, ...column }) => column)}
          initialPage={{ sortField: 'createdDate', sortDirection: 'desc' }}
          initialColumns={initialColumns}
          onRowClick={restoreTransaction}
          filterByLocation
        />
      </div>
    </div>
  );
};

export default Drafts;
